export default {
  call: '呼叫',
  text: '短信',
}
